import { IApiProblemDetails } from "../common/models/IApiProblemDetails";
import { AppNotificationTypeEnum } from "../contexts/app-notification-context/AppNotificationContextTypes";
import { useAppNotificationContext } from "../contexts/app-notification-context/UseAppNotificationContext";
import { RestError } from "../services/rest-service/RestService";
import { BaseUseQueryParameters } from "./BaseUseQueryParameters";

// use type inference and utility higher order types ReturnType<T> and Parameters<T>.
export function useQueryNotifications<T extends (...args: any[]) => any>
    (fn: T): (...funcArgs: Parameters<T>) => ReturnType<T> {

    const [, setAppNotificationState] = useAppNotificationContext();
    
    function onError(error: RestError) {

        const problemDetails = (error.response?.data as unknown) as IApiProblemDetails;
        setAppNotificationState({
            notificationType: AppNotificationTypeEnum.Error,
            message: problemDetails?.message,
            hideContactInfo: true,
            error: !problemDetails?.message ? error : undefined,
            show: true
        });

    }

    return function(...args: Parameters<T>): ReturnType<T> {

        const copy = [...args];
       
        if (copy.length > 0 && !copy[0].hasOwnProperty("onError")) {
            const theargs = copy[0] as BaseUseQueryParameters<T>;
            theargs.onError = onError;
        }

        return fn(...copy);
    };
}      
